import './whatsapp_message_content.js.coffee'

Monitoring.Models.SocialContents ||= {}

String::endsWith = (s) ->
  this[this.length-s.length...] == s

class Monitoring.Models.SocialContents.WhatsappMediaMessageContent extends Monitoring.Models.SocialContents.WhatsappMessageContent

  getMediaUrl: ->
    @json.attachment.url

  getMediaType: ->
    @json.attachment.mimeType
